import React from 'react';
import './Brands.css';

const brands = [
  { name: 'Ford', domain: 'ford.com' },
  { name: 'Toyota', domain: 'toyota.com' },
  { name: 'Honda', domain: 'honda.com' },
  { name: 'Chevrolet', domain: 'chevrolet.com' },
  { name: 'BMW', domain: 'bmw.com' },
  { name: 'Mercedes', domain: 'mbusa.com' },
  { name: 'Audi', domain: 'audi.com' },
  { name: 'Nissan', domain: 'nissanusa.com' },
  { name: 'Hyundai', domain: 'hyundaiusa.com' },
  { name: 'Kia', domain: 'kia.com' },
  { name: 'Dodge', domain: 'dodge.com' },
  { name: 'Jeep', domain: 'jeep.com' },
  { name: 'Volkswagen', domain: 'vw.com' },
  { name: 'Subaru', domain: 'subaru.com' },
  { name: 'Lexus', domain: 'lexus.com' },
  { name: 'Acura', domain: 'acura.com' },
];

const Brands = () => {
  return (
    <section className="brands" id="brands">
      <div className="brands-container">
        <div className="brands-header">
          <div className="section-badge light">ALL MAJOR BRANDS</div>
          <h2>We Supply Parts For All<br />Major Car Brands</h2>
          <p>From domestic to import, economy to luxury — we've got parts for every make and model.</p>
        </div>

        <div className="brands-grid">
          {brands.map((b, i) => (
            <div className="brand-item" key={i}>
              <div className="brand-logo-wrapper">
                <img 
                  src={`https://logo.clearbit.com/${b.domain}`} 
                  alt={`${b.name} logo`} 
                  className="brand-logo"
                  onError={(e) => { e.target.style.display = 'none'; }}
                />
              </div>
              <span className="brand-name">{b.name}</span>
            </div>
          ))}
        </div>

        <div className="brands-note">
          <span>Don't see your brand?</span>
          <a href="#contact">Contact us — we source parts for ALL vehicles</a>
        </div>
      </div>
    </section>
  );
};

export default Brands;
